<template>
<section :class="{'only-one': data.length <= 1}" class="factor-chart-wrapper">
  <section
    v-for="(item, index) in data"
    :key="index"
    class="factor-chart-site-wrapper"
  >
    <section class="factor-chart-header">
      <span class="factor-chart-site-name">{{item.name}}</span>
    </section>
    <section
      v-for="factorGroup in factorTree"
      :key="factorGroup.id"
      :class="{'only-one': factorTree.length <= 1}"
      class="factor-chart"
    >
      <section
        ref="factorCharts"
        :is="factorGroup.id === vocsGroupId ? 'VOCsChart' : (factorGroup.id === meteorologicalGroupId ? 'MeteorologicalChart' : 'DefaultFactorChart')"
        :factor-group="factorGroup"
        :data="item.data"
        :data-times="dataTimes"
        :unit-prop="unitProp"
      ></section>
    </section>
  </section>
</section>
</template>

<script>
import BaseStore from '../../BaseStore'

export default {
  name: 'FactorCharts',
  extends: BaseStore,
  data () {
    return {
      factorTree: [],
      data: [],
      unitProp: 'displayUnit',
      dataTimes: []
    }
  },
  computed: {
    vocsGroupId: () => process.env.VOCS_GROUP_ID,
    meteorologicalGroupId: () => process.env.METEOROLOGICAL_GROUP_ID
  },
  methods: {
    renderChart (param) {
      this.setParam(param)
      this.buildFactorTree()
      this.renderCharts()
    },
    setParam ({factorIds, sites, data, unitProp, dataTimeFormat}) {
      this.factorIds = factorIds
      this.data = this.getFormatData(sites, data)
      this.unitProp = unitProp
      this.dataTimes = Object.freeze(data.map(data => new Date(data.ts).format(dataTimeFormat)))
    },
    getFormatData (sites, data) {
      let siteMap = sites.reduce((map, site) => {
        let siteId = site.id
        map[siteId] = {
          name: site.name,
          data: []
        }
        return map
      }, {})

      siteMap = data.reduce((map, data) => {
        let item = map[data.siteId]
        item.data.push(data)
        return siteMap
      }, siteMap)

      return Object.freeze(Object.values(siteMap))
    },
    buildFactorTree () {
      let {factorMap} = this
      let factorGroupMap = JSON.parse(JSON.stringify(this.factorGroupMap))
      let factors = this.factorIds.map(factorId => factorMap[factorId])
      let factorTree = []

      for (let i = 0; i < factors.length; i++) {
        let factor = factors[i]
        let {parentId} = factor
        let parent = factorGroupMap[parentId]

        if (parent) {
          let {children} = parent

          if (!Array.isArray(children)) {
            children = parent.children = []
            factors.splice(i + 1, 0, parent)
          }

          children.push(factor)
        } else {
          factorTree.push(factor)
        }
      }

      this.factorTree = Object.freeze(factorTree)
    },
    renderCharts () {
      setTimeout(() => {
        let factorCharts = this.$refs.factorCharts || []
        factorCharts.forEach(factorChart => {
          factorChart.render()
        })
      }, 0)
    }
  },
  beforeDestroy () {
    this.factorIds = this.data = this.unit = null
  }
}
</script>

<style lang="scss" scoped>
.factor-chart-wrapper {
  $HEADER-HEIGHT: 32px;

  width: 100%;
  height: 100%;

  &.only-one {
    > .factor-chart-site-wrapper {
      min-height: 100%;
    }
  }

  > .factor-chart-site-wrapper {
    position: relative;
    height: 400px;
    padding-top: $HEADER-HEIGHT;
    overflow: auto;
  }

  .factor-chart {
    height: 400px;

    &.only-one {
      min-height: 100%;
    }
  }

  .factor-chart-header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: $HEADER-HEIGHT;
    background: linear-gradient(to right, #00c0ef 0%, #fff 100%);
  }

  .factor-chart-site-name {
    font: {
      size: 1rem;
      weight: 700;
    };
    line-height: 2;
    padding: 0 1em;
    color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/FactorCharts/index.vue